import React from 'react';
import styled from 'styled-components';
import FlexboxContainer from 'components/UI/FlexboxContainer';
import { Main, Background, Shade, Text } from 'styles/themeColors';
import { Space } from 'styles/themeSpaces';
import { BorderRadius } from 'styles/themeBorderRadius';
import { LabelPosition } from 'types/position';

const Input = styled.input`
  display: none;

  &:checked + .toggle {
    background-color: ${Shade.shade120};
  }

  &:checked + .toggle > .slider {
    align-self: flex-end;
  }
`;

const Slider = styled.div`
  height: 12px;
  width: 12px;
  border-radius: ${BorderRadius.xl};
  margin: ${Space.spHalf};
`;

const Label = styled.label<any>`
  text-align: center;
`;

const SwitchLabel = styled.label<any>`
  background-color: ${Main.white};
  width: 46px;
  height: 24px;
  border-radius: ${BorderRadius.l};
  display: flex;
  flex-direction: column;
  cursor: pointer;

  &.toggle-active {
    background-color: ${Main.brandLight};
    align-items: flex-end;
  }
`;

interface Props {
  id: string;
  className?: string;
  name?: string;
  value?: string;
  checked?: boolean;
  label?: string;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  labelPosition?: LabelPosition;
  margin?: string;
};

const Switch = ({
  id,
  className = '',
  name,
  value,
  checked = false,
  label,
  onChange,
  disabled = false,
  labelPosition = 'right',
  margin = `0 0 0 ${Space.spBasePlus}`
}: Props) => {
  const labelStyle = labelPosition === 'left'
    ? { marginRight: `${Space.spHalfPlus}` }
    : { marginLeft: `${Space.spHalfPlus}` };

  const labelElement = <Label htmlFor={id} className="base" style={labelStyle}>{label}</Label>;

  return (
    <FlexboxContainer
      alignItems="center"
      padding={label ? `${Space.spHalfPlus} ${Space.sp2x} ${Space.spHalfPlus} 0` : '0'}
      displayFlex="inline-flex"
      margin={margin}
    >
      {label && labelPosition === 'left' ? labelElement : null}
      <Input
        id={id}
        className={className}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={e => onChange(e.target.checked)}
        type="checkbox"
      />
      <SwitchLabel htmlFor={id} className={checked ? 'toggle-active' : 'toggle'} style={{ border: checked ? `2px solid ${Main.brandLight}` : `2px solid ${Main.lightGray}` }}>
        <Slider style={{ backgroundColor: checked ? `${Background.white}` : `${Text.secondary}` }} className="slider" />
      </SwitchLabel>
      {label && labelPosition === 'right' ? labelElement : null}
    </FlexboxContainer>
  );
};

export default Switch;
